import { Typography } from "@mui/material";
import globals from "../../globals";

const TitleTypography = ({value}) =>{
    return(
        <Typography sx={{color: globals.colors.darkBlue, fontSize:20, fontWeight:'bold'}}>
            {value}
        </Typography>
    );
}

export default TitleTypography;